import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import * as authenticationTypes from '../../types';

@Component({
  selector: 'tr-login',
  templateUrl: './login.component.html',
  //styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  signInForm: FormGroup;
  @Output() authenticate = new EventEmitter<authenticationTypes.ICredentials>();
  @Input() isBusy: boolean;
  @Input() message: string;
  @Input() userName: string;

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    let password: '';

    this.signInForm = this.fb.group({
      'username': [ this.userName, Validators.compose([ Validators.required, CustomValidators.email ]) ],
      'password': [ password, Validators.required ]
    });
  }

  onSubmit(): void {
      this.authenticate.emit(this.signInForm.value);
    }

}



// WEBPACK FOOTER //
// ./src/app/authentication/components/login/login.component.ts